module.exports = __webpack_public_path__ + "static/media/sell_take_order_help_1.5e52b7e0.jpg";